var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_30889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7854 2.00098C19.3416 2.00098 19.8982 2.00098 20.4545 2.00098C20.4434 2.0162 20.4339 2.03294 20.4217 2.04701C18.4562 4.33858 16.49 6.63014 14.5245 8.9217C14.1463 9.36267 13.7685 9.80363 13.3888 10.2465C13.4238 10.3013 13.45 10.3443 13.4782 10.3854C15.6461 13.549 17.8144 16.7122 19.9812 19.8765C20.3453 20.4084 20.7018 20.9453 21.0617 21.4798H15.4087C15.3866 21.4418 15.3668 21.4022 15.3421 21.3665C13.6719 18.928 12.0016 16.4896 10.3306 14.0516C10.3032 14.0116 10.2693 13.9762 10.2313 13.9302C10.1723 13.9972 10.1217 14.0531 10.0726 14.1105C8.72462 15.6815 7.37624 17.2521 6.02976 18.8238C5.27224 19.708 4.51739 20.5945 3.76178 21.4798H2.09229C2.14175 21.4152 2.18816 21.3474 2.24105 21.2858C4.46222 18.6959 6.68416 16.1069 8.90572 13.5178C9.10242 13.2887 9.29722 13.0585 9.49126 12.8306C9.45664 12.7781 9.43267 12.7408 9.40756 12.7043C7.01859 9.21695 4.62849 5.72957 2.23953 2.24181C2.18664 2.1642 2.14137 2.08126 2.09229 2.00098C3.97675 2.00098 5.86083 2.00098 7.74529 2.00098C7.76013 2.02875 7.77268 2.05805 7.79018 2.08354C9.38169 4.40706 10.9739 6.73058 12.5654 9.0541C12.589 9.08873 12.6069 9.12716 12.632 9.17243C14.7048 6.75683 16.7453 4.37891 18.7854 2.00098ZM4.36254 3.26337C4.40896 3.33718 4.43065 3.37561 4.45576 3.41175C8.34301 8.9879 12.2306 14.5637 16.116 20.1413C16.1807 20.2346 16.2484 20.273 16.3625 20.2722C17.1082 20.2673 17.8543 20.2699 18.6001 20.2692C18.6469 20.2692 18.694 20.2627 18.7667 20.257C18.7108 20.1722 18.6716 20.1098 18.6297 20.0493C17.023 17.744 15.4159 15.4384 13.8088 13.1335C11.5538 9.89913 9.29798 6.66514 7.04637 3.42811C6.96076 3.30484 6.87211 3.25614 6.72259 3.25995C6.3056 3.27022 5.88822 3.26337 5.47123 3.26337C5.11321 3.26337 4.75481 3.26337 4.36216 3.26337H4.36254Z",
    fill: "url(#paint0_linear_99_30889)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_30889",
    x1: 1.00049,
    y1: 18.4756,
    x2: 30.5005,
    y2: -9.02441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_30889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.0995,
    height: 19.48,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5ddbb967d4e3aa7818857b5e9a6e3fd0.svg";
export { ForwardRef as ReactComponent };